import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import { IErrorMessage } from '../../components/errorMessage/errorMessage.type';
import InputField from '../../components/InputField';
import ValidationErrors from '../validationErrors';
import ValueFormatters from '../valueFormatters';
import { KannaValidator } from './kanaValidator';

interface IFirstNameKanaFieldProps {
    autoFocus?: boolean;
    intl: InjectedIntl;
    value?: string;
    required?: boolean;
}

class FirstNameKanaField extends React.Component<IFirstNameKanaFieldProps> {
    private readonly ID: string;
    private readonly LABEL_ID: string;
    private readonly ERROR_REQUIRED_ID: string;
    private readonly ERROR_VALIDATE_ID: string;

    private readonly MAX_LENGTH: number;

    constructor(props: IFirstNameKanaFieldProps) {
        super(props);

        this.ID = 'firstNameKana';
        this.LABEL_ID = 'label.first_name_kana';
        this.ERROR_REQUIRED_ID = 'error.first_name_kana_required';
        this.ERROR_VALIDATE_ID = 'error.first_name_kana_validated';
        this.MAX_LENGTH = 85;

        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
    }

    public render() {
        return <Field name={this.ID} validate={this.validate} render={this.renderInputField} />;
    }

    private validate(value: string): IErrorMessage {
        const { required } = this.props;

        if (!value && required) {
            return TranslationHelpers.getMessageDescriptor(this.ERROR_REQUIRED_ID);
        }

        if (value && value.length > this.MAX_LENGTH) {
            return ValidationErrors.fieldTooLongMessageProps(this.MAX_LENGTH);
        }

        if (value && !KannaValidator.katakanaValidation(value)) {
            return TranslationHelpers.getMessageDescriptor(this.ERROR_VALIDATE_ID);
        }
        return '';
    }

    private renderInputField({
        field,
        form: { touched, errors, setFieldValue, handleBlur },
    }: FieldProps): ReactNode {
        const { autoFocus, value, required } = this.props;
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
            setFieldValue(this.ID, ValueFormatters.trimExtraSpaces(event.target.value));
            handleBlur(event);
        };
        return (
            <InputField
                autoComplete="given-name"
                labelMessage={TranslationHelpers.getMessageDescriptor(this.LABEL_ID)}
                type="text"
                id={this.ID}
                maxLength={this.MAX_LENGTH}
                name={this.ID}
                value={value}
                error={errorMessage}
                autoFocus={autoFocus}
                required={required}
                onBlur={onBlur}
            />
        );
    }
}
export default injectIntl(FirstNameKanaField);
